import React from 'react';
import { SuperTable, saveSortingPersonalization } from '@nile/components';
import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import { isEmpty } from 'lodash';

function RMMTable(props) {
  const {
    isLoading,
    context,
    columns,
    listInfoDetails,
    defaultOptions = {
      page: 1,
      pageSize: 50,
      hasMore: null,
      totalCount: 0,
      sort: null
    },
    defaultColumnCells,
    data = [],
    user,
    rowCount,
    setRowCount,
    saveTableRowCount,
    saveColumnWidth,
    tableName,
    columnWidthPersonalization,
    refreshTable,
    getAttributeName,
    listInfo,
    pageSize,
    activePage,
    ldFlagEnabled,
    noBulkSelect,
    cardTable,
    emptyState,
    hideBorderTop,
    fullHeight,
    recordCount,
    pagination,
    pages,
    dynamicRowCount,
    padded,
    isClientPagination,
    checkDisabledRow,
    setCurrentPagination,
    disableSelectAll,
    checkBoxSize,
    sortingPersonalization = false,
    viewId = 'default',
    overscan = null,
    currentPage,
    noOverscan,
    defaultShowFilter = false,
    enableSelectAll,
    maintainSelection,
    idKey
  } = props;
  return (
    <>
      {ldFlagEnabled ? (
        <SuperTable
          isLoading={isLoading}
          context={context}
          noBulkSelect={noBulkSelect}
          columns={columns}
          listInfo={isEmpty(listInfoDetails) ? defaultOptions : listInfoDetails}
          defaultColumnCells={defaultColumnCells}
          data={data}
          user={user}
          rowCount={rowCount}
          setRowCount={setRowCount}
          saveTableRowCount={saveTableRowCount}
          saveColumnWidth={saveColumnWidth}
          tableName={tableName}
          columnWidthPersonalization={columnWidthPersonalization}
          refreshTable={refreshTable}
          getAttributeName={getAttributeName}
          skipPageReset={false}
          cardTable={cardTable}
          fullHeight={fullHeight}
          emptyState={emptyState}
          hideBorderTop={hideBorderTop}
          padded={padded}
          isClientPagination={isClientPagination}
          disableSelectAll={disableSelectAll}
          checkDisabledRow={checkDisabledRow}
          setCurrentPage={setCurrentPagination}
          dynamicRowCount={false}
          checkBoxSize={checkBoxSize}
          sortingPersonalization={sortingPersonalization}
          saveSortingPersonalization={saveSortingPersonalization}
          viewId={viewId}
          overscan={overscan}
          noOverscan={noOverscan}
          defaultShowFilter={defaultShowFilter}
          enableSelectAll={enableSelectAll}
          maintainSelection={maintainSelection}
          idKey={idKey}
        />
      ) : (
        <TableView
          disableSelectAll={disableSelectAll}
          isLoading={isLoading}
          context={context}
          noBulkSelect={noBulkSelect}
          columns={columns}
          listInfo={isEmpty(listInfo) ? defaultOptions : listInfo}
          defaultColumnCells={defaultColumnCells}
          data={data}
          rowCount={pageSize || rowCount}
          refreshTable={refreshTable}
          getAttributeName={getAttributeName}
          skipPageReset={false}
          pagination={pagination}
          pages={pages}
          activePage={activePage}
          recordCount={recordCount}
          cardTable={cardTable}
          fullHeight={fullHeight}
          emptyState={emptyState}
          hideBorderTop={hideBorderTop}
          isClientPagination={isClientPagination}
          checkDisabledRow={checkDisabledRow}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      )}
    </>
  );
}
export default RMMTable;
